import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { CorrectionFieldComponent } from '@features/correction-field/correction-field.component';

@Component({
    template: ` <app-correction-field [correction]="params.value" /> `,
    styleUrl: 'correction-cell.component.scss',
    imports: [CorrectionFieldComponent],
})
export class CorrectionCellComponent implements ICellRendererAngularComp {
    public params!: ICellRendererParams;

    agInit(params: ICellRendererParams): void {
        this.params = params;
    }

    refresh() {
        return false;
    }
}
